import React, { useEffect, useState } from "react";
import { Amplify, Auth } from "aws-amplify";
import LoadingSpinner from "../common/loading";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import "./console.css";
import SchemaEditView from "../schema/schema-edit-view";
import SchemaManageView from "../schema/schema-manage-view";
import { developerAccessTokenState, originalPathState } from "../global-state";
import { useRecoilState } from "recoil";
import PlaygroundView from "../playground/playground-view";
import { Layout, Menu, Button, Dropdown, Space } from "antd";
import {
  MenuOutlined,
  UserOutlined,
  ArrowLeftOutlined,
  UpOutlined,
  DownOutlined,
  ExperimentOutlined,
  UserAddOutlined,
  DatabaseOutlined,
  BarChartOutlined,
  RobotOutlined,
  AppstoreOutlined,
  ThunderboltOutlined,
  BugOutlined,
  FileOutlined,
  BellOutlined,
  InboxOutlined,
  SearchOutlined,
  SettingOutlined,
  HistoryOutlined,
  ExclamationCircleOutlined,
  ApiOutlined,
  CodeOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import theme from "../theme";
import { DEV_AUTH_CONFIG } from "../aws-config";
import LandingPage from "./landing-page";
import WaitlistUsersView from "./waitlist";
import UiWidgetView from "../ui/ui-widget";
import StasticsView from "../statistics/statistics-view";
import ExecutionStasticsView from "../statistics/execution-statistics-view";
import AutomationStasticsView from "../statistics/automation-statistics-view";
import UserStasticsView from "../statistics/user-statistics-view";
import AssistantStasticsView from "../statistics/assistant-statistics-view";
import AssistantHistoryList from "../history/assistant-history-list";
import QuickWordView from "../quickword/quick-word-view";
import PremadeScriptView from "../premade/premade-script-view";
import PremadeManageView from "../premade/premade-manage-view";
import PremadeSearchView from "../premade/premade-search-view";
import NotificationListView from "../notification/notification-list-view";
import Debug from "../debug/debug";
import DebugInvokePlan from "../debug/debug-invoke-plan";
import DebugByte from "../debug/debug-byte";
import DebugAgent from "../debug/debug-agent";
import DebugScopeData from "../debug/debug-scope-data";
import ErrorScriptView from "../assistant/error-script-view";
import ModelView from "../assistant/model-view";
import CacheView from "../system/cache-view";
import TelegramView from "../messaging/telegram-view";

const drawerWidth = 240;
const { Header, Sider, Content } = Layout;

const routes = [
  {
    path: "/playground",
    exact: true,
    main: () => <PlaygroundView />,
  },
  {
    path: "/schema/edit",
    exact: true,
    main: () => <SchemaEditView />,
  },
  {
    path: "/schema/manage",
    exact: true,
    main: () => <SchemaManageView />,
  },
  {
    path: "/waitlist",
    exact: true,
    main: () => <WaitlistUsersView />,
  },
  {
    path: "/ui-widget",
    exact: true,
    main: () => <UiWidgetView />,
  },
  {
    path: "/statistics",
    exact: true,
    main: () => <StasticsView />,
  },
  {
    path: "/statistics/execution",
    exact: true,
    main: () => <ExecutionStasticsView />,
  },
  {
    path: "/statistics/automation",
    exact: true,
    main: () => <AutomationStasticsView />,
  },
  {
    path: "/statistics/user",
    exact: true,
    main: () => <UserStasticsView />,
  },
  {
    path: "/statistics/assistant",
    exact: true,
    main: () => <AssistantStasticsView />,
  },
  {
    path: "/assistant",
    exact: true,
    main: () => <AssistantHistoryList />,
  },
  {
    path: "/assistant/error-script",
    exact: true,
    main: () => <ErrorScriptView />,
  },
  {
    path: "/assistant/model",
    exact: true,
    main: () => <ModelView />,
  },
  {
    path: "/system/cache",
    exact: true,
    main: () => <CacheView />,
  },
  {
    path: "/quick-word",
    exact: true,
    main: () => <QuickWordView />,
  },
  {
    path: "/premade/manage",
    exact: true,
    main: () => <PremadeManageView />,
  },
  {
    path: "/premade/search",
    exact: true,
    main: () => <PremadeSearchView />,
  },
  {
    path: "/notification",
    exact: true,
    main: () => <NotificationListView />,
  },
  {
    path: "/debug",
    exact: true,
    main: () => <Debug />,
  },
  {
    path: "/debug-invoke-plan",
    exact: true,
    main: () => <DebugInvokePlan />,
  },
  {
    path: "/debug-byte",
    exact: true,
    main: () => <DebugByte />,
  },
  {
    path: "/debug-agent",
    exact: true,
    main: () => <DebugAgent />,
  },
  {
    path: "/debug-scope-data",
    exact: true,
    main: () => <DebugScopeData />,
  },
  {
    path: "/messaging/telegram",
    exact: true,
    main: () => <TelegramView />,
  },
  {
    path: "/",
    exact: true,
    main: () => <LandingPage />,
  },
];

const ConsoleAppBar = ({ developer, onMenu }) => {
  const location = useLocation();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      Amplify.configure(DEV_AUTH_CONFIG);
      await Auth.signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const developerMenu = {
    items: [
      {
        key: "user",
        label: `Hello, ${developer}`,
        disabled: true,
      },
      {
        key: "logout",
        label: "Logout",
        onClick: handleLogout,
      },
    ],
  };

  const getTitle = () => {
    switch (location.pathname) {
      case "/playground":
        return "Device Playground";
      case "/waitlist":
        return "Waitlist";
      case "/schema/edit":
        return "Schema Edit";
      case "/schema/manage":
        return "Schema Manage";
      case "/ui-widget":
        return "Twin Schema";
      case "/statistics":
        return "Statistics";
      case "/statistics/execution":
        return "Execution Statistics";
      case "/statistics/automation":
        return "Automation Statistics";
      case "/statistics/user":
        return "User Statistics";
      case "/statistics/assistant":
        return "Assistant Statistics";
      case "/assistant":
        return "Assistant History";
      case "/assistant/error-script":
        return "Error Script";
      case "/assistant/model":
        return "Model Management";
      case "/system/cache":
        return "Cache Management";
      case "/quick-word":
        return "Quick Commands";
      case "/premade/manage":
        return "Premade Manage";
      case "/premade/script":
        return "Premade Script";
      case "/premade/search":
        return "Premade Search";
      case "/notification":
        return "Notification Manager";
      case "/messaging/telegram":
        return "Telegram Bot Manager";
      case "/debug":
        return "Automation Debugger";
      case "/debug-invoke-plan":
        return "Invoke Plan Debugger";
      case "/debug-byte":
        return "Byte Decoder";
      case "/debug-agent":
        return "Agent Debugger";
      case "/debug-scope-data":
        return "Scope Data Debugger";
      default:
        return "Automation Console";
    }
  };

  return (
    <Header
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        padding: "0 16px",
        backgroundColor: "#1976d2",
        color: "#fff",
      }}
    >
      <Button
        type="text"
        icon={<MenuOutlined />}
        onClick={onMenu}
        style={{
          marginRight: 16,
          color: "#fff",
        }}
        className="mobile-menu-button"
      />
      <Space style={{ flex: 1 }}>
        {location.pathname.startsWith("/statistics/") && (
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              history.push("/statistics");
            }}
            style={{ color: "#fff" }}
          />
        )}
        {location.pathname.startsWith("/assistant/") && (
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              history.push("/assistant");
            }}
            style={{ color: "#fff" }}
          />
        )}
        {location.pathname === "/premade/script" && (
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              history.goBack();
            }}
            style={{ color: "#fff" }}
          />
        )}
        <h6 style={{ margin: 0, color: "#fff", fontSize: "1.25rem", fontWeight: 500 }}>
          {getTitle()}
        </h6>
      </Space>
      <Dropdown menu={developerMenu} placement="bottomRight">
        <Button
          type="text"
          icon={<UserOutlined style={{ fontSize: "20px" }} />}
          style={{ color: "#fff", fontSize: "20px" }}
        />
      </Dropdown>
    </Header>
  );
};

const Console = () => {
  const [developerAuthState, setDeveloperAuthState] = useState(false);
  const [userName, setUserName] = useState("");
  const [originalPath, setOriginalPath] = useRecoilState(originalPathState);
  const [developerAccessToken, setDeveloperAccessToken] = useRecoilState(
    developerAccessTokenState,
  );
  const path = useLocation();
  const [navOpen, setNavOpen] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [sidebarVisible, setSidebarVisible] = useState(true); // 控制侧边栏显示/隐藏
  const [schemaCollapsed, setSchemaCollapsed] = useState(true);
  const [premadeCollapsed, setPremadeCollapsed] = useState(true);
  const [assistantCollapsed, setAssistantCollapsed] = useState(true);
  const [uiCollapsed, setUiCollapsed] = useState(true);
  const [debugCollapsed, setDebugCollapsed] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    checkDeveloperAuthState();
    const intervalId = setInterval(() => {
      console.log("Refresh token!");
      checkDeveloperAuthState();
    }, 10 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  const checkDeveloperAuthState = async () => {
    setOriginalPath(path.pathname + path.search + path.hash);
    try {
      Amplify.configure(DEV_AUTH_CONFIG);
      const session = await Auth.currentSession();
      const email = session.getIdToken().payload["cognito:username"];
      const accessToken = session.getAccessToken().getJwtToken();
      setDeveloperAccessToken(accessToken);
      setDeveloperAuthState(true);
      setUserName(email);
    } catch (error) {
      setDeveloperAuthState(false);
      console.log(error);
      history.push("/developer-login");
    }
  };

  const handleSchemaCollapsed = () => {
    setSchemaCollapsed(!schemaCollapsed);
  };
  const handlePremadeCollapsed = () => {
    setPremadeCollapsed(!premadeCollapsed);
  };

  const handleAssistantCollapsed = () => {
    setAssistantCollapsed(!assistantCollapsed);
  };

  const handleUiCollapsed = () => {
    setUiCollapsed(!uiCollapsed);
  };

  const handleDebugCollapsed = () => {
    setDebugCollapsed(!debugCollapsed);
  };

  const toggleNav = () => {
    // 导航栏的显示/隐藏只能通过这个按钮控制
    // 切换内容时不会影响导航栏的显示状态
    if (isLargeScreen) {
      // 大屏幕：切换侧边栏显示/隐藏（通过按钮控制）
      setSidebarVisible(!sidebarVisible);
    } else {
      // 小屏幕：切换移动端侧边栏显示/隐藏（通过按钮控制）
    setNavOpen(!navOpen);
    }
  };

  const navPlayground = () => {
    history.push("/playground");
  };

  const navSchemaManage = () => {
    history.push("/schema/manage");
  };

  const navWaitlist = () => {
    history.push("/waitlist");
  };

  const navUiWidget = () => {
    history.push("/ui-widget");
  };

  const navStatistics = () => {
    history.push("/statistics");
  };

  const navAssistantHistory = () => {
    history.push("/assistant");
  };

  const navErrorScript = () => {
    history.push("/assistant/error-script");
  };

  const navModelView = () => {
    history.push("/assistant/model");
  };

  const navQuickWord = () => {
    history.push("/quick-word");
  };

  const navPremadeManage = () => {
    history.push("/premade/manage");
  };

  const navPremadeSearch = () => {
    history.push("/premade/search");
  };

  const navNotification = () => {
    history.push("/notification");
  };

  const navCacheView = () => {
    history.push("/system/cache");
  };

  const navTelegramBots = () => {
    history.push("/messaging/telegram");
  };

  const navDebug = () => {
    history.push("/debug");
  };

  const navDebugInvokePlan = () => {
    history.push("/debug-invoke-plan");
  };

  const navDebugByte = () => {
    history.push("/debug-byte");
  };

  const navDebugAgent = () => {
    history.push("/debug-agent");
  };

  const navDebugScopeData = () => {
    history.push("/debug-scope-data");
  };

  const menuItems = [
    {
      key: "playground",
      label: "Playground",
      icon: <ExperimentOutlined />,
    },
    {
      key: "waitlist",
      label: "Waitlist",
      icon: <UserAddOutlined />,
    },
    {
      key: "schema",
      label: "Schema",
      icon: <DatabaseOutlined />,
      children: [
        {
          key: "schema-manage",
          label: "Manage",
          icon: <SettingOutlined />,
        },
      ],
    },
    {
      key: "statistics",
      label: "Statistics",
      icon: <BarChartOutlined />,
    },
    {
      key: "assistant",
      label: "Assistant",
      icon: <RobotOutlined />,
      children: [
        {
          key: "assistant-history",
          label: "History",
          icon: <HistoryOutlined />,
        },
        {
          key: "assistant-error-script",
          label: "Error Script",
          icon: <ExclamationCircleOutlined />,
        },
        {
          key: "assistant-model",
          label: "Model",
          icon: <ApiOutlined />,
        },
      ],
    },
    {
      key: "ui",
      label: "UI",
      icon: <AppstoreOutlined />,
      children: [
        {
          key: "ui-widget",
          label: "Twin Schema",
          icon: <AppstoreOutlined />,
        },
      ],
    },
    {
      key: "quick-word",
      label: "Quick Commands",
      icon: <ThunderboltOutlined />,
    },
    {
      key: "debug",
      label: "Debug",
      icon: <BugOutlined />,
      children: [
        {
          key: "debug-automation",
          label: "Automation",
          icon: <RobotOutlined />,
        },
        {
          key: "debug-invoke-plan",
          label: "Invoke Plan",
          icon: <ThunderboltOutlined />,
        },
        {
          key: "debug-byte",
          label: "Byte Decoder",
          icon: <CodeOutlined />,
        },
        {
          key: "debug-agent",
          label: "Agent",
          icon: <ApiOutlined />,
        },
        {
          key: "debug-scope-data",
          label: "Scope Data",
          icon: <DatabaseOutlined />,
        },
      ],
    },
    {
      key: "premade",
      label: "Premade",
      icon: <FileOutlined />,
      children: [
        {
          key: "premade-manage",
          label: "Manage",
          icon: <SettingOutlined />,
        },
        {
          key: "premade-search",
          label: "Search",
          icon: <SearchOutlined />,
        },
      ],
    },
    {
      key: "notification",
      label: "Notification",
      icon: <BellOutlined />,
    },
    {
      key: "messaging-telegram",
      label: "Telegram Bots",
      icon: <MessageOutlined />,
    },
    {
      key: "cache",
      label: "Cache Management",
      icon: <InboxOutlined />,
    },
  ];

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case "playground":
        navPlayground();
        break;
      case "waitlist":
        navWaitlist();
        break;
      case "schema-manage":
        navSchemaManage();
        break;
      case "statistics":
        navStatistics();
        break;
      case "assistant-history":
        navAssistantHistory();
        break;
      case "assistant-error-script":
        navErrorScript();
        break;
      case "assistant-model":
        navModelView();
        break;
      case "ui-widget":
        navUiWidget();
        break;
      case "quick-word":
        navQuickWord();
        break;
      case "debug-automation":
        navDebug();
        break;
      case "debug-invoke-plan":
        navDebugInvokePlan();
        break;
      case "debug-byte":
        navDebugByte();
        break;
      case "debug-agent":
        navDebugAgent();
        break;
      case "debug-scope-data":
        navDebugScopeData();
        break;
      case "premade-manage":
        navPremadeManage();
        break;
      case "premade-search":
        navPremadeSearch();
        break;
      case "notification":
        navNotification();
        break;
      case "messaging-telegram":
        navTelegramBots();
        break;
      case "cache":
        navCacheView();
        break;
      default:
        break;
    }
    // 只有小屏幕时，点击菜单项后自动关闭导航栏
    // 大屏幕时，导航栏保持显示状态，不会因为切换内容而隐藏
    if (!isLargeScreen) {
      setNavOpen(false);
    }
    // 注意：大屏幕时不会改变 sidebarVisible，导航栏的显示/隐藏只能通过按钮控制
  };

  const handleMenuOpenChange = (openKeys) => {
    setSchemaCollapsed(!openKeys.includes("schema"));
    setAssistantCollapsed(!openKeys.includes("assistant"));
    setUiCollapsed(!openKeys.includes("ui"));
    setDebugCollapsed(!openKeys.includes("debug"));
    setPremadeCollapsed(!openKeys.includes("premade"));
  };

  return (
    <div>
      {!developerAuthState ? (
        <LoadingSpinner />
      ) : (
        <Layout style={{ minHeight: "100vh" }}>
          <ConsoleAppBar developer={userName} onMenu={toggleNav} />
          <Layout style={{ marginTop: 64, display: "flex", flexDirection: "row", height: "calc(100vh - 64px)" }}>
            {isLargeScreen && sidebarVisible && (
            <Sider
              width={drawerWidth}
              style={{
                  height: "100%",
                overflow: "auto",
                  backgroundColor: theme.palette.background.card,
                  boxShadow: "2px 0 8px rgba(0, 0, 0, 0.1)",
                  borderRight: `1px solid ${theme.palette.background.l1}`,
                  flexShrink: 0,
              }}
            >
              <Menu
                mode="inline"
                  style={{ 
                    height: "100%", 
                    borderRight: 0,
                    backgroundColor: theme.palette.background.card,
                    padding: "8px 0",
                  }}
                items={menuItems}
                onClick={handleMenuClick}
                onOpenChange={handleMenuOpenChange}
                openKeys={[
                  ...(!schemaCollapsed ? ["schema"] : []),
                  ...(!assistantCollapsed ? ["assistant"] : []),
                  ...(!uiCollapsed ? ["ui"] : []),
                  ...(!debugCollapsed ? ["debug"] : []),
                  ...(!premadeCollapsed ? ["premade"] : []),
                ]}
              />
            </Sider>
            )}
            {!isLargeScreen && navOpen && (
              <>
                <div
                  style={{
                    position: "fixed",
                    top: 64,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                    zIndex: 998,
                  }}
                  onClick={() => setNavOpen(false)}
                />
              <Sider
                width={drawerWidth}
                style={{
                  position: "fixed",
                  left: 0,
                  top: 64,
                  bottom: 0,
                  overflow: "auto",
                  zIndex: 999,
                    backgroundColor: theme.palette.background.card,
                    boxShadow: "2px 0 8px rgba(0, 0, 0, 0.15)",
                    borderRight: `1px solid ${theme.palette.background.l1}`,
                }}
              >
                <Menu
                  mode="inline"
                    style={{ 
                      height: "100%", 
                      borderRight: 0,
                      backgroundColor: theme.palette.background.card,
                      padding: "8px 0",
                    }}
                  items={menuItems}
                  onClick={handleMenuClick}
                  onOpenChange={handleMenuOpenChange}
                  openKeys={[
                    ...(!schemaCollapsed ? ["schema"] : []),
                    ...(!assistantCollapsed ? ["assistant"] : []),
                    ...(!uiCollapsed ? ["ui"] : []),
                    ...(!debugCollapsed ? ["debug"] : []),
                    ...(!premadeCollapsed ? ["premade"] : []),
                  ]}
                />
              </Sider>
              </>
            )}
            <Layout 
              style={{ 
                flex: 1,
                height: "100%",
                transition: "all 0.2s",
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Content
                style={{
                  flex: 1,
                  padding: 24,
                  background: theme.palette.background.default,
                  width: "100%",
                  boxSizing: "border-box",
                  overflow: "auto",
                  height: "100%",
                }}
              >
                <Switch>
                  {routes.map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.main}
                    />
                  ))}
                </Switch>
              </Content>
            </Layout>
          </Layout>
        </Layout>
      )}
    </div>
  );
};

export default Console;
